export default {
  defaultPaymentMethod: "Default Payment Method",
  creditCardDetails: "Credit Card Details",
  cardInfo: "Payment Methods",

  // popup
  actionRequiredBeforeRemovingThisCard:
    "Action Required Before Removing This Card",
  haveUnpaidCharges:
    "You have active product usage with unpaid charges ({count} credit). | You have active product usage with unpaid charges ({count} credits).",
  removingYourLastPaymentMethodMayPauseYourAccess:
    "Removing your last payment method will pause your active products (such as sequences). Please clear outstanding charges or add another card to avoid service interruption.",
  btnViewCharge: "View Charge",
  RemoveCreditCard: "Remove Credit Card",

  // pending payments
  transactionDetails: "Transaction details",
  accountAdmin: "Account admin",
  btnPayNow: "Pay now",
  paymentAmount: "Amount",
  totalChargeCredit: "Total Charge Credit",
  tabPendingPayments: "Pending payments",
  paySuccess: "pay success",

  // empty table content
  noPendingPayments: "No Pending Payments",
  anyPendingChargesWillShowUp:
    "Any pending charges will show up here when it's time to pay.",

  settings_billing_title: "Billing & Payments",
  settings_billing_desc:
    "Take control of your billing with a clear view of your payment setup. Manage credit cards, review invoice history, and monitor pending charges to keep your subscription running smoothly.",
  invoice_no: "Invoice no",
  transaction_date: "Transaction date",
  transaction_details: "Transaction details",
  transaction_amount: "Amount",

  accpeted_cards: "Accepted Cards",
  add_new_card: "Add new card",
  set_as_default_payment_method: "Set as default payment method",
  country_region: "Country/Region",
  digit3_4: "3-digit / 4-digit",
  payment_security_tip:
    "Your payment details are securely processed with SSL encryption.",

  payment_add_failed_title: "Credit Card Addition Failed",
  contact_support: "Contact Support",
  try_later: "Try Later",
  payment_add_failed_issue: "There was an issue adding your card.",
  payment_add_failed_unavailable:
    "Bank server unavailable. Please try again later.",

  charge_remove_card: "Charge And Remove Card",

  billing_invoice_view_invoices: "View invoices",
  billing_invoice_art_label: "An invoice paid by bank transfer",
  billing_invoice_title: "Bank transfer",
  billing_invoice_desc: "We send an invoice for every top-up. No card is needed.",
  billing_invoice_terms: "Payment terms",
  billing_invoice_terms_months: "{count} month after the invoice date | {count} months after the invoice date",
  billing_invoice_terms_years: "{count} year after the invoice date | {count} years after the invoice date",
  billing_invoice_currency: "Currency",
  billing_invoice_topup_desc: "Billed by invoice, no card needed. Pick from the amounts in your agreement.",
  billing_invoice_topup_tooltip: "Each automatic top-up is billed by invoice and paid by bank transfer. No card is charged.",
  billing_invoice_not_enough: "Your account team tops up this account and bills it by invoice. Contact them to add credits now.",
  billing_invoice_wallet: "billed by invoice"
};
